import React from 'react';
import {connect} from 'react-redux';

import {orderBy} from 'lodash';

import EquipmentTableAndSearch from './EquipmentTableAndSearch';
import SensorsTableAndSearch from './SensorsTableAndSearch';

import TabPanel, { Tab } from '../../components/TabPanel';
import usePermissions from '../../hooks/usePermissions';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './SystemItemDataInsert.module.css';

const SystemItemDataInsert = (props) => {
    const isFullArchitectAllowed = usePermissions('architectFull');

    const handleSort = (props, property) => {
        return (event) => {
            props.reorderItems(property);
        };
    };

    return (
        <div className={classes.root}>
            <TabPanel
                aria-label="System Item Options"
                classes={{
                    root: classes.tabPanel
                }}
            >
                <Tab title="Sensors">
                    <SensorsTableAndSearch
                        isFullArchitectAllowed={isFullArchitectAllowed}
                        sensors={props.sensors}
                        order={props.order}
                        orderBy={props.orderBy}
                        handleSort={handleSort}
                        onToggleDeleteSensorModal={props.onToggleDeleteSensorModal}
                        onToggleEditSensorModal={props.onToggleEditSensorModal}
                        onTogglePreviewDataModal={props.onTogglePreviewDataModal}
                        selectedNode={props.selectedNode}
                    />
                </Tab>
                <Tab title="Equipment Associations">
                    <EquipmentTableAndSearch
                        equipment={props.filteredEquipment}
                        order={props.order}
                        orderBy={props.orderBy}
                        handleSort={handleSort}
                        onToggleDeleteEquipmentEntityModal={props.onToggleDeleteEquipmentEntityModal}
                        isFullArchitectAllowed={isFullArchitectAllowed}
                        selectedNode={props.selectedNode}
                    />
                </Tab>
            </TabPanel>
        </div>
    );
};

const mapStateToProps = state => {
    const {
        filteredEquipment,
        order,
        orderBy: orderByKey,
        selectedNode,
        sensors
    } = state.architect;

    return {
        currentScopes:     state.core.currentScopes,
        filteredEquipment: orderBy(filteredEquipment, [orderByKey], order),
        order,
        orderBy:           orderByKey,
        selectedNode,
        sensors:           orderBy(sensors, [orderByKey], order)
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemItemDataInsert);
